<template>
  <v-row row justify-center>
    <v-dialog v-model="country_dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline" :class="`${language == 'ar' ? 'arFont' : null}`">{{ i18n.country_choose }}</span>
        </v-card-title>
        <v-card-text>
          <v-row wrap>
            <v-col xs12>
              <v-autocomplete
                :label="i18n.country_choose"
                :loading="loading"
                solo
                return-object
                required
                :class="`specialInput ${language == 'ar' ? 'arFont' : null}`"
                :style="`${language == 'ar' ? 'direction:rtl;' : null}`"
                item-text="name"
                :items="countries"
                :rules="[() => !selectedCountry || 'You must choose at least one']"
                v-model="selectedCountry"
                @change="manualCountry()"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="secondary" 
            text 
            @click="countryDialog()"
            :class="`specialInput ${language == 'ar' ? 'arFont' : null}`"
            :style="`${language == 'ar' ? 'direction:rtl;' : null}`"
          >
            {{i18n.cancel}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  data() {
    return {
      selectedCountry:null
    }
  },
  methods: {
    manualCountry() {
      this.$store.dispatch('manualCountry', this.selectedCountry)
      this.countryDialog()
    },
    countryDialog(){
      this.$store.state.country_dialog = false
    },
  },
  computed: {
    country_dialog(){
      return this.$store.state.country_dialog
    },
    countries(){
      return this.$store.state.countries
    },
    country(){
      return this.$store.state.country
    },
    i18n(){
      return this.$store.state.i18n
    },
    language(){
      return this.$store.state.language
    },
    loading(){
      return this.$store.state.loading
    },
  },
  created(){
    if(this.country) {
      this.selectedCountry = this.country
    }
  }
}
</script>
